import { checkElementInView } from 'propel/checkElementInView';

const quickLinksButtons = document.querySelectorAll(
	'.block-quick-links__button'
);

const quickLinkLinks = document.querySelectorAll(
	'.block-quick-links__link[href^="#"]'
);

const clickButton = (e) => {
	if (!e.currentTarget.nextElementSibling) {
		return;
	}

	e.preventDefault();

	if (e.currentTarget.classList.contains('block-quick-links__button--open')) {
		e.currentTarget.classList.remove('block-quick-links__button--open');
		e.currentTarget.nextElementSibling.setAttribute(
			'aria-expanded',
			'false'
		);
	} else {
		e.currentTarget.classList.add('block-quick-links__button--open');
		e.currentTarget.nextElementSibling.setAttribute(
			'aria-expanded',
			'true'
		);
	}
};

const changeButtonText = (newText) => {
	quickLinksButtons.forEach((quickLinksButton) => {
		quickLinksButton.innerText = newText;
	});
};

const clickLink = (e) => {
	quickLinkLinks.forEach((quickLinkLink) => {
		quickLinkLink.classList.remove('block-quick-links__link--active');
	});

	e.currentTarget.classList.add('block-quick-links__link--active');

	changeButtonText(e.currentTarget.innerText);

	const content = e.currentTarget.closest('.block-quick-links__content');

	if (content) {
		content.previousElementSibling.classList.remove(
			'block-quick-links__button--open'
		);
		content.setAttribute('aria-expanded', 'false');
	}
};

const inView = (e) => {
	if (!e.id) {
		return;
	}

	if (document.body.classList.contains('smooth-scrolling')) {
		return;
	}

	const sectionId = e.id;

	quickLinkLinks.forEach((quickLinkLink) => {
		if (`#${sectionId}` === quickLinkLink.getAttribute('href')) {
			quickLinkLink.classList.add('block-quick-links__link--active');

			changeButtonText(quickLinkLink.innerText);
		} else {
			quickLinkLink.classList.remove('block-quick-links__link--active');
		}
	});
};

const notInView = (e) => {
	if (!e.id) {
		return;
	}

	if (document.body.classList.contains('smooth-scrolling')) {
		return;
	}

	const sectionId = e.id;

	const rect = e.getBoundingClientRect();

	if (rect.top >= window.innerHeight / 2) {
		quickLinkLinks.forEach((quickLinkLink) => {
			if (`#${sectionId}` === quickLinkLink.getAttribute('href')) {
				if (
					quickLinkLink?.parentElement?.parentElement
						?.previousElementSibling?.children[0]
				) {
					quickLinkLink.parentElement.parentElement.previousElementSibling.children[0].classList.add(
						'block-quick-links__link--active'
					);

					changeButtonText(
						quickLinkLink.parentElement.parentElement
							.previousElementSibling.children[0].innerText
					);
				}
			}

			quickLinkLink.classList.remove('block-quick-links__link--active');
		});
	} else {
		let currentQuickLink;

		quickLinkLinks.forEach((quickLinkLink) => {
			if (`#${sectionId}` === quickLinkLink.getAttribute('href')) {
				currentQuickLink = quickLinkLink;
			}
		});

		if (
			currentQuickLink?.parentElement?.parentElement?.nextElementSibling
				?.children[0]
		) {
			const nextSectionSelector =
				currentQuickLink.parentElement.parentElement.nextElementSibling.children[0].getAttribute(
					'href'
				);

			const nextSection = document.querySelector(nextSectionSelector);

			if (nextSection) {
				const nextSectionRect = nextSection.getBoundingClientRect();

				if (nextSectionRect.top <= window.innerHeight / 2) {
					quickLinkLinks.forEach((quickLinkLink) => {
						if (
							nextSectionSelector ===
							quickLinkLink.getAttribute('href')
						) {
							quickLinkLink.classList.add(
								'block-quick-links__link--active'
							);

							changeButtonText(quickLinkLink.innerText);
						} else {
							quickLinkLink.classList.remove(
								'block-quick-links__link--active'
							);
						}
					});
				}
			}
		}
	}
};

if (quickLinksButtons.length > 0) {
	quickLinksButtons.forEach((quickLinksButton) => {
		quickLinksButton.addEventListener('click', clickButton);
	});
}

if (quickLinkLinks.length > 0) {
	quickLinkLinks.forEach((quickLinkLink) => {
		quickLinkLink.addEventListener('click', clickLink);

		const anchor = quickLinkLink.getAttribute('href');

		checkElementInView(anchor, inView, notInView, {
			root: null,
			rootMargin: '0px 0px -50% 0px',
			threshold: [0],
		});
	});
}
